import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { Button, LinkTo } from '../../../helpers';

function RingGroupDelete({ organizationId, item, onDelete }) {
  return (
    <div className="row">
      <div className="col-12">
        <div className="alert alert-danger">
          You are about to delete:&nbsp;
          <LinkTo href={`organizations/${organizationId}/ringGroups/${item.id}/show`}>
            {get(item, 'attributes.name')}
          </LinkTo>
          .&nbsp; Are you sure?
        </div>

        <div className="btn-group">
          <LinkTo button icon="times-circle" color="secondary" href={`organizations/${organizationId}/ringGroups`}>
            Cancel
          </LinkTo>
          <Button button icon="trash" color="danger" onClick={() => onDelete(item)}>
            Yes, Delete
          </Button>
        </div>
      </div>
    </div>
  );
}

RingGroupDelete.propTypes = {
  organizationId: PropTypes.string.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default RingGroupDelete;
